(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('ReporteEvaluativoOORegenerarService', ReporteEvaluativoOORegenerarService);

    ReporteEvaluativoOORegenerarService.$inject = ['$resource'];

    function ReporteEvaluativoOORegenerarService ($resource) {
    	var resourceUrl =  'apo/reporteEvaluativo/regenerarreporteOO:idA,:idP,:idAnio,:idIndice,:ic,:iic,:tipoEvaluacion,:idDependencia,:nivell,:modeloo';

        return $resource(resourceUrl, {}, {
        	'regenerar': {
            	method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
            	url:'apo/guardarreporteooregenerar:id',
            	method:'PUT' 
            }
        });
    }
})();
